;(function ($) {
    $.fn.naturataProductInfoTabs = function () {
        return $(this).each(function () {
            var container = $(this);
            var tabs = container.find('.tab-content');
            var minHeight = 0;

            tabs.each(function() {
                var contentHeight = $(this).height();
                if(contentHeight > minHeight) {
                    minHeight = contentHeight;
                }
            });

            tabs.css('min-height', minHeight);
        });
    };
    $(function () {
        $('[data-naturata-tabbed-content]').naturataProductInfoTabs();

        $(window).resize(function() {
			$('[data-naturata-tabbed-content]').naturataProductInfoTabs();
        });
    });
})(jQuery);
